import React from "react";
import { ArrowRightIcon, CheckIcon, XIcon } from "lucide-react";
import { transformation } from "../data/transformation";
import { images } from "../data/images";
export function TransformationSection() {
  return <section aria-labelledby="transformacion-titulo" className="relative overflow-hidden bg-cocoa-950 pb-14 text-cream-100 sm:pb-28" data-id="element-280" data-mp="2wwm41zj0t85f">
      <header className="bg-cocoa-900 px-5 py-3 text-center" data-id="element-281" data-mp="2s0nazymqz1yo">
        <h2 id="transformacion-titulo" className="text-xs font-semibold uppercase tracking-[0.3em] text-caramel-300" data-id="element-282" data-mp="2ny0pefgo6d9x">
          La transformación
        </h2>
      </header>

      <div className="mx-auto mt-10 max-w-6xl px-5 sm:mt-20" data-id="element-283" data-mp="2e6ml7udrwpag">
        <div className="grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-end" data-id="element-284" data-mp="2e51teciufkga">
          <div className="min-w-0 text-center" data-id="element-285" data-mp="299mh3p0hhwlz">
            <p className="mx-auto max-w-md font-display text-2xl leading-snug text-cream-50 sm:text-3xl" data-id="element-286" data-mp="248qctac808g1">
              De cocinar por gusto a <em className="font-medium text-caramel-300" data-id="element-287" data-mp="208fz1bi6sdqm">organizar tu propio emprendimiento</em>
            </p>
            <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-cream-200 sm:text-lg" data-id="element-288" data-mp="f9hpjiu5oegu">
              Decisiones claras, números reales y un sistema simple para tus pedidos.
            </p>
          </div>
          <img src={images.alfajores} alt="Alfajores artesanales de dulce de leche" className="hidden aspect-[4/3] w-full rounded-2xl object-cover ring-1 ring-caramel-500/30 lg:block" data-id="element-289" data-mp="5atjlifg3pti" />
        </div>

        {/* Encabezados de columna (escritorio) */}
        <div className="mt-14 hidden grid-cols-2 gap-0 px-1 md:grid" data-id="element-290" data-mp="12ykfrf2uvfmy">
          <p className="flex items-center gap-2 pl-6 text-xs font-semibold uppercase tracking-[0.2em] text-cream-300" data-id="element-291" data-mp="p03wyprpxyog">
            <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-292" data-mp="t0nw1yvurcd8" />
            Hoy
          </p>
          <p className="flex items-center gap-2 pl-10 text-xs font-semibold uppercase tracking-[0.2em] text-caramel-300" data-id="element-293" data-mp="39pjndjn0zldk">
            <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-294" data-mp="3dqd8y6czwo3a" />
            Con el plan de 30 días
          </p>
        </div>

        <ul className="mt-8 space-y-4 md:mt-4 md:space-y-3" data-id="element-295" data-mp="1facrta8igp21">
          {transformation.map(row => <li key={row.before} className="grid overflow-hidden rounded-2xl ring-1 ring-caramel-500/25 md:grid-cols-[1fr_0_1fr]" data-id="element-296" data-mp="1ajo2o1kb0462">
              {/* Hoy */}
              <div className="flex items-start gap-3 bg-cocoa-900 p-5 md:items-center md:p-6" data-id="element-297" data-mp="11k0zpbbxeqaw">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full ring-1 ring-cream-50/20" data-id="element-298" data-mp="wjvcc7covpym">
                  <XIcon className="h-3.5 w-3.5 text-cream-300" aria-hidden="true" data-id="element-299" data-mp="rm39wjef4lg6" />
                </span>
                <div data-id="element-300" data-mp="mnihv79bl82t">
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-cream-300/80 md:hidden" data-id="element-301" data-mp="mobjxuxc39em">Hoy</span>
                  <p className="mt-0.5 text-[15px] leading-snug text-cream-300 md:mt-0" data-id="element-302" data-mp="2h0hwoy5vly91">{row.before}</p>
                </div>
              </div>

              {/* Flecha central */}
              <div className="relative z-10 h-0 md:h-auto md:w-0" aria-hidden="true" data-id="element-303" data-mp="2pffqf7vhayma">
                <span className="absolute left-1/2 top-1/2 flex h-9 w-9 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-caramel-500 text-cocoa-950 ring-4 ring-cocoa-900" data-id="element-304" data-mp="2tgr9eujuklli">
                  <ArrowRightIcon className="h-4 w-4 rotate-90 md:rotate-0" data-id="element-305" data-mp="33ahvxtweylyk" />
                </span>
              </div>

              {/* Con el plan */}
              <div className="flex items-start gap-3 border-t border-caramel-500/20 bg-cocoa-800 p-5 pt-6 md:items-center md:border-l md:border-t-0 md:p-6 md:pl-10" data-id="element-306" data-mp="2al1530ofzd4g">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-caramel-500 text-cocoa-950" data-id="element-307" data-mp="2khw5jp49znld">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-308" data-mp="3qx6iwu0a54m1" />
                </span>
                <div data-id="element-309" data-mp="3vwjf45d1jo1a">
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.2em] text-caramel-300 md:hidden" data-id="element-310" data-mp="3vvrj4tfj7oah">Con el plan</span>
                  <p className="mt-0.5 text-[15px] font-semibold leading-snug text-cream-50 md:mt-0 md:text-base" data-id="element-311" data-mp="13psape3ogc0z">{row.after}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-center font-display text-2xl leading-snug text-cream-50 sm:mt-14 sm:text-3xl" data-id="element-312" data-mp="1cqqhg45i2xn9">
          Misma cocina, mismas recetas. <span className="italic text-caramel-400" data-id="element-313" data-mp="1rlwpewo5p6j8">Otra forma de trabajar.</span>
        </p>
      </div>
    </section>;
}